import { Outlet } from "react-router-dom";

export default function AuthLayout() {
    return (
        <div
            className="flex align-items-center justify-content-center min-h-screen"
            style={{
                background: "linear-gradient(135deg, #dceff9 0%, #ffffff 60%)"
            }}
        >
            <Outlet />
        </div>
    );
}
